import React, { Fragment, useState } from 'react';
import styled from 'styled-components';
import Player from '@vimeo/player';

import VideoOverlay from './VideoOverlay';

const PLAYER_BASE_URL = 'https://player.vimeo.com/video/';

const Iframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const onIframeLoad = (e, playSetter) => {
  const player = new Player(e.target);

  player.on('play', () => playSetter(true));
  player.on('pause', () => playSetter(false));
};

const VideoPlayer = ({ videoId }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  return(
    <Fragment>
      <Iframe src={PLAYER_BASE_URL + videoId}
              onLoad={(e) => onIframeLoad(e, setIsPlaying)}
              allowFullScreen />
      {isPlaying || <VideoOverlay />}
    </Fragment>
  );
};

export default VideoPlayer;
